import { Injectable } from '@angular/core';

import { BaseEditCreateCopyService, HttpService, NotificationService } from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export abstract class TmsWebBaseEditCreateCopyService<T, TEdit> extends BaseEditCreateCopyService<T, TEdit> {
  protected constructor(
    protected baseRoute: string,
    public name: string,
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super(baseRoute, name, httpService, notificationService);
  }

  protected get apiUrl() {
    return `TmsWeb/${this.baseRoute}`;
  }
}
